import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getBibliotecasPlantillaFiltered,
  deleteBibliotecaPlantilla,
  getBibliotecasPlantillaFilteredWithFiles,
  updateBibliotecaPlantilla,
  insertBibliotecaPlantilla,
  getBibliotecaPlantillaById,
  updateBibliotecasPlantillaProducto,
  getBibPlantillasByProductoId,
} from 'services/personalizacion'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_BIBPLANTILLA_FILTERED(action) {
  try {
    const bibliotecasPlantillaData = yield call(getBibliotecasPlantillaFiltered, action.payload)
    if (bibliotecasPlantillaData.ok) {
      yield put({
        type: actions.BIBPLANTILLA_FILTERED_LOAD_SUCCEEDED,
        payload: bibliotecasPlantillaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Bibliotecas de Plantilla')
      put({
        type: actions.BIBPLANTILLA_FILTERED_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BIBPLANTILLA_FILTERED_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBPLANTILLA_FILTERED_WITH_FILES(action) {
  try {
    const bibliotecasPlantillaData = yield call(
      getBibliotecasPlantillaFilteredWithFiles,
      action.payload,
    )
    if (bibliotecasPlantillaData.ok) {
      yield put({
        type: actions.BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_SUCCEEDED,
        payload: bibliotecasPlantillaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Bibliotecas de Plantilla')
      put({
        type: actions.BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBPLANTILLA(action) {
  try {
    const descuentoData = yield call(deleteBibliotecaPlantilla, action.payload)
    if (descuentoData.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Plantilla eliminada correctamente')
      yield put({
        type: actions.DELETE_BIBPLANTILLA_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar el Biblioteca de Plantilla')
      put({
        type: actions.DELETE_BIBPLANTILLA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar el Biblioteca de Plantilla')
    yield all([
      put({
        type: actions.DELETE_BIBPLANTILLA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBPLANTILLA(action) {
  try {
    const bibPlantilla = yield call(insertBibliotecaPlantilla, action.payload)
    if (bibPlantilla.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Plantilla creada correctamente')
      yield put({
        type: actions.BIBPLANTILLA_INSERT_SUCCEEDED,
        payload: bibPlantilla.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Biblioteca de Plantilla')
      yield put({
        type: actions.BIBPLANTILLA_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Biblioteca de Plantilla')
    yield all([
      put({
        type: actions.BIBPLANTILLA_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBPLANTILLA(action) {
  try {
    const bibPlantilla = yield call(updateBibliotecaPlantilla, action.payload)
    if (bibPlantilla.ok) {
      putMessage(messageType.SUCCESS, 'Biblioteca de Plantillas modificada correctamente')
      yield put({
        type: actions.BIBPLANTILLA_UPDATE_SUCCEEDED,
        payload: bibPlantilla.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Plantillas')
      yield put({
        type: actions.BIBPLANTILLA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Plantillas')
    yield all([
      put({
        type: actions.BIBPLANTILLA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBPLANTILLA_BY_ID(action) {
  try {
    const bibliotecasPlantillaData = yield call(getBibliotecaPlantillaById, action.payload)
    if (bibliotecasPlantillaData.ok) {
      yield put({
        type: actions.BIBPLANTILLA_BYID_LOAD_SUCCEEDED,
        payload: bibliotecasPlantillaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Plantilla')
      put({
        type: actions.BIBPLANTILLA_BYID_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BIBPLANTILLA_BYID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBSPLANTILLA_PRODUCTO(action) {
  try {
    const bibliotecasPlantillaByProducto = yield call(
      updateBibliotecasPlantillaProducto,
      action.payload,
    )
    if (bibliotecasPlantillaByProducto.ok) {
      putMessage(
        messageType.SUCCESS,
        'Bibliotecas de Plantillas modificada correctamente para este producto',
      )
      yield put({
        type: actions.BIBSPLANTILLA_PRODUCTO_UPDATE_SUCCEEDED,
        payload: bibliotecasPlantillaByProducto.data,
      })
    } else {
      putMessage(
        messageType.ERROR,
        'Error al modificar Bibliotecas de Plantillas para este producto',
      )
      yield put({
        type: actions.BIBSPLANTILLA_PRODUCTO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Plantillas para este producto')
    yield all([
      put({
        type: actions.BIBSPLANTILLA_PRODUCTO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBPLANTILLA_BY_PRODUCTO_ID(action) {
  try {
    const bibliotecasPlantillaData = yield call(getBibPlantillasByProductoId, action.payload)
    if (bibliotecasPlantillaData.ok) {
      yield put({
        type: actions.BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_SUCCEEDED,
        payload: bibliotecasPlantillaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Plantillas')
      put({
        type: actions.BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Plantillas')
    yield all([
      put({
        type: actions.BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.BIBPLANTILLA_FILTERED_LOAD_REQUESTED, GET_BIBPLANTILLA_FILTERED),
    takeEvery(
      actions.BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_REQUESTED,
      GET_BIBPLANTILLA_FILTERED_WITH_FILES,
    ),
    takeEvery(actions.DELETE_BIBPLANTILLA_REQUESTED, DELETE_BIBPLANTILLA),
    takeEvery(actions.BIBPLANTILLA_INSERT_REQUESTED, INSERT_BIBPLANTILLA),
    takeEvery(actions.BIBPLANTILLA_UPDATE_REQUESTED, UPDATE_BIBPLANTILLA),
    takeEvery(actions.BIBPLANTILLA_BYID_LOAD_REQUESTED, GET_BIBPLANTILLA_BY_ID),
    takeEvery(actions.BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_REQUESTED, GET_BIBPLANTILLA_BY_PRODUCTO_ID),
    takeEvery(actions.BIBSPLANTILLA_PRODUCTO_UPDATE_REQUESTED, UPDATE_BIBSPLANTILLA_PRODUCTO),
  ])
}
